import { render, staticRenderFns } from "./UserItemGroup.vue?vue&type=template&id=bd90e5aa&scoped=true&"
import script from "./UserItemGroup.vue?vue&type=script&lang=ts&"
export * from "./UserItemGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd90e5aa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
